export default "__VITE_ASSET__DJI0yV_R__"